import { Component, OnInit } from '@angular/core';
import { Car } from 'src/app/interfaces/car';
import { AlertController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-cars',
  templateUrl: './cars.page.html',
  styleUrls: ['./cars.page.scss'],
})
export class CarsPage implements OnInit {
  selectedView = 'main';
  editFields = false;
  editedId: string;

  matriculaField: string;
  marcaField: string;
  modeloField: string;

  columns = [
    {
      field: 'matricula',
      name: 'matrícula',
      width: 25
    },
    {
      field: 'marca',
      name: 'marca',
      width: 25
    },
    {
      field: 'modelo',
      name: 'modelo',
      width: 25
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 15,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        }
      ]
    }
  ];

  lines: Car[];
  filteredLines: Car[];
  carsForm: FormGroup;

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService
  ) {
    this.carsForm = new FormGroup({
      matricula: new FormControl('', [Validators.required]),
      marca: new FormControl('', [Validators.required]),
      modelo: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this.getCars();
  }

  changeView(view: string) {
    this.selectedView = view;
  }

  addNew() {
    this.selectedView = 'editMode';
    this.clearData();
    this.editFields = false;
    console.log('addnew');
  }

  async getCars() {
    await this.utils.showLoading();
    const result: any = await this.rest.getCars(1, 1000);
    this.lines = result.body.records;
    this.filteredLines = this.lines;
    await this.utils.hideLoading();
  }

  async saveItem() {
    const sendCar: Car = {
      matricula: this.matriculaField,
      marca: this.marcaField,
      modelo: this.modeloField
    };

    await this.utils.showLoading();
    const result = await this.rest.createCar(sendCar);
    console.log(result);
    if (result) {
      this.clearData();
      this.selectedView = 'main';
      this.getCars();
    }
    await this.utils.hideLoading();
  }

  async editItem() {
    const sendCar: Car = {
      _id: this.editedId,
      matricula: this.matriculaField,
      marca: this.marcaField,
      modelo: this.modeloField
    };

    await this.utils.showLoading();
    const result = await this.rest.editCar(sendCar);
    console.log(result);
    if (result) {
      this.selectedView = 'main';
      this.getCars();
    }
    await this.utils.hideLoading();
  }

  async doAction(data) {
    console.log(data);
    const car: Car = data.line;
    if (data.action === 'delete') {
      this.deleteItem(car);
    }
    if (data.action === 'edit') {
      console.log('edit');
      this.selectedView = 'editMode';
      this.editedId = car._id;
      this.matriculaField = car.matricula;
      this.marcaField = car.marca;
      this.modeloField = car.modelo;
      this.editFields = true;
    }
  }

  async deleteItem(car: Car) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar coche ' + car.matricula,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deleteCar(car._id);
            this.getCars();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  clearData() {
    this.matriculaField = '';
    this.marcaField = '';
    this.modeloField = '';
  }

  search(event: any) {
    this.filteredLines = this.lines;
    var filter = event.target.value;
    // Contains:
    var cars = this.lines.map(car => car.modelo);
    cars = cars.filter(n => n.toLowerCase().includes(filter.toLowerCase()));
    this.filteredLines = this.filteredLines.filter(car => cars.includes(car.modelo));
    // Starts with:
    // this.filteredLines = this.filteredLines.filter(car => car.modelo.toLowerCase().startsWith(filter));
  }
}
